export default {
  siteInfo: {
    open: false,
    page: "about",
  },
};
